import { Button, CircularProgress, ButtonProps, Box } from '@mui/material';
import { theme } from 'theme';

const styles = (displayGrid: boolean) => {
  return {
    wrapper: {
      display: displayGrid ? 'grid' : 'inline-flex',
      position: 'relative',
    },
    buttonProgress: {
      color: theme.palette.common.white,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  };
};

type Props = {
  loading?: boolean;
  displayGrid?: boolean;
} & ButtonProps;

export const LoadingButton = ({
  disabled = false,
  loading = false,
  displayGrid = false,
  children,
  ...props
}: Props) => {
  return (
    <Box data-testid={'loading-button'} sx={styles(displayGrid).wrapper}>
      <Button id="loading-button" {...props} disabled={loading || disabled}>
        {children}
      </Button>
      {loading && <CircularProgress size={24} sx={styles(displayGrid).buttonProgress} />}
    </Box>
  );
};
